export const mockProduct = {
  ProductId: 0,
  CategoryId: 2,
  Name: "",
  Description: "",
  SKU: "",
  Barcode: "",
  Price: 0,
  FeeOption: 1,
  TaxRate: 0,
  Picture: null,
  PictureFile: null,
  Inventory: 0,
  InternalOnly: false,
  Variations: [],
  Options:[]
}

export const mockVariation = {
  VariationId: 0,
  Name: "",
  Cost: 0,
  Inventory: null,
  SKU: ""
}

export const mockOption = {
  OptionId: 0,
  Name: "",
  Cost: 0,
  Inventory: 0,
  TrackInventory: false,
  SKU: ""
}

export const mockFeeOptions = [
  {
    Id: 1,
    Name: "Fees Paid by You"
  },
  {
    Id: 2,
    Name: "Split Fees"
  },
  {
    Id: 3,
    Name: "Fees Paid By Purchaser"
  }
]